import { ReactNode } from 'react'

import Card from 'app/frontend/base/components/Card'

type ActorAbilityContainerProps = {
  labels: ReactNode
  labelsInCard?: boolean
}

const ActorAbilityContainer = ({
  labels,
  labelsInCard = true,
}: ActorAbilityContainerProps) => {
  return (
    <div className='shrink-0'>
      {labels ? (
        labelsInCard ? (
          <Card className='py-0 px-1 rounded-[8px]'>{labels}</Card>
        ) : (
          labels
        )
      ) : null}
    </div>
  )
}

export default ActorAbilityContainer
